export const ALFRED_CLIENT_LIST_ORIGIN_STATE = {
  fromAlfredClientList: true,
} as const

export type AlfredClientSortColumn = "clientId" | "venueCode"
export type AlfredClientSortDirection = "asc" | "desc"

export interface AlfredClientListHistoryState {
  sortColumn: AlfredClientSortColumn | null
  sortDirection: AlfredClientSortDirection
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null
}

export function getAlfredClientListHistoryState(
  state: unknown,
): AlfredClientListHistoryState | undefined {
  if (!isRecord(state) || !isRecord(state.alfredClientList)) return undefined

  const snapshot = state.alfredClientList
  const sortColumn = snapshot.sortColumn
  const sortDirection = snapshot.sortDirection

  if (
    sortColumn !== null &&
    sortColumn !== "clientId" &&
    sortColumn !== "venueCode"
  ) {
    return undefined
  }

  if (sortDirection !== "asc" && sortDirection !== "desc") return undefined

  return { sortColumn, sortDirection }
}

export function isAlfredClientListOrigin(state: unknown): boolean {
  return isRecord(state) && state.fromAlfredClientList === true
}
